// The design system calls moment.tz.setDefault('Africa/Casablanca') when it is imported. That pins every
// moment() in the app to moment-timezone's bundled Casablanca rules, which can disagree with the browser's
// clock (e.g. +01:00 vs +00:00) and shift appointment hours. Import it first, then go back to the browser zone.
import '@sobrus-com/sobrus-design-system';
import moment from 'moment-timezone';

moment.tz.setDefault();
